import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface DirectorTeamLeaveRequest {
  id: string;
  userId: string;
  userName: string;
  userRole: string;
  leaveType: string;
  reason: string;
  fromDate: string;
  toDate: string;
  numberOfDays: number;
  status: "Pending" | "Approved" | "Rejected";
  appliedDate: string;
  approvedBy?: string;
  avatar?: string;
}

export interface DirectorTeamLeaveRequestData {
  requests: DirectorTeamLeaveRequest[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

export interface DirectorTeamLeaveRequestResponse {
  success: boolean;
  data: DirectorTeamLeaveRequestData;
  message?: string;
}

const getDirectorTeamLeaveRequests = async (
  page = 1,
  limit = 10,
  status = "Pending"
): Promise<DirectorTeamLeaveRequestResponse> => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());
  queryParams.append("limit", limit.toString());
  queryParams.append("status", status);

  const { data } = await customAxios.get<DirectorTeamLeaveRequestResponse>(
    `/leaves/director/team/requests?${queryParams.toString()}`
  );
  return data;
};

export const useGetDirectorTeamLeaveRequests = (
  page = 1,
  limit = 10,
  status = "Pending"
) =>
  useQuery<DirectorTeamLeaveRequestResponse, AxiosError>(
    ["director-team-leave-requests", page, limit, status],
    () => getDirectorTeamLeaveRequests(page, limit, status),
    {
      staleTime: 60000, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
